var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYearW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_736_94)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 4.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 1.8125V7.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 1.8125V7.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.404785 14.875H37.192",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65355 29.625L11.1736 23.271H12.4516L14.9446 29.625H13.4506L11.5426 24.351H12.0556L10.1206 29.625H8.65355ZM10.0846 28.473V27.321H13.5496V28.473H10.0846ZM15.6169 29.625V23.271H16.6069L17.0299 24.54V29.625H15.6169ZM19.9999 29.625L16.2559 24.828L16.6069 23.271L20.3509 28.068L19.9999 29.625ZM19.9999 29.625L19.6219 28.356V23.271H21.0349V29.625H19.9999ZM22.2614 29.625V23.271H23.2514L23.6744 24.54V29.625H22.2614ZM26.6444 29.625L22.9004 24.828L23.2514 23.271L26.9954 28.068L26.6444 29.625ZM26.6444 29.625L26.2664 28.356V23.271H27.6794V29.625H26.6444Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_736_94",
    x: -4,
    y: -3.1875,
    width: 46,
    height: 48.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_736_94"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_736_94",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearW);
export default __webpack_public_path__ + "static/media/yearW.fd5b4c825bd5fb27c2a9e6bc4fd5e074.svg";
export { ForwardRef as ReactComponent };